import { render, staticRenderFns } from "./ParticipantList.vue?vue&type=template&id=56df2126&"
import script from "./ParticipantList.vue?vue&type=script&lang=js&"
export * from "./ParticipantList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ParticipantList.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VList } from 'vuetify/lib'
import { VListTile } from 'vuetify/lib'
import { VListTileContent } from 'vuetify/lib'
import { VListTileTitle } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
installComponents(component, {
  VContainer,
  VFlex,
  VLayout,
  VList,
  VListTile,
  VListTileContent,
  VListTileTitle,
  VSpacer,
})
